import RightHeader from './RightHeader.vue';

export default RightHeader;
